import React, { useState, useCallback } from "react";
import { useAnonymousInterceptor } from "@components/with-anonymous";
import { VOTE_UP, VOTE_DOWN, VOTE_RESET, update, VoteBar } from "mibaby-frontend/social/VoteBar";

/**
 * The VoteBarContainer shows a bar with a UpVote and a DownVote Component.
 * It also shows a textual representation of the current count.
 *
 * the container is a self managed component.
 *
 * You can specify the initialValue, and a initialCount.
 * Both will then be managed and modified by the container.
 * You can specify a onChange handler that will be called on every change.
 * Subsequent prop changes to intialValue or initialCount will be ignored.
 *
 *
 * @param {{
 *  className?: string,
 *  onChange: (ev: React.SyntheticEvent<HTMLButtonElement>, value: {selected: 0 | 1 | -1, sum: number, ups: number, downs: number;}) => void,
 *  initialSelected: VOTE_ENUM,
 *  initialSum: Number,
 *  initialDowns: Number,
 *  initialUps: Number,
 *  buttonProps?: VoteButtonProps,
 *  upProps?: VoteButtonProps,
 *  downProps?: VoteButtonProps
 *  userOnly?: boolean
 *  registerLightboxId?: number
 * }} param0
 */
export const VoteBarContainer = ({
  onChange,
  initialSum = 0,
  initialSelected = VOTE_RESET,
  initialUps = 0,
  initialDowns = 0,
  userOnly = false,
  registerLightboxId,
  ...props
}) => {
  const [{ selected, sum, ups, downs }, setValue] = useState({
    selected: initialSelected,
    sum: initialSum,
    ups: initialUps,
    downs: initialDowns,
  });
  /**
   * @type {(method:VOTE_ENUM) => (e: React.SyntheticEvent<HTMLButtonElement>) => void}
   */
  const createHandler = method => e => {
    const nextState = update(selected, method, sum, ups, downs);
    setValue(nextState);
    onChange(e, nextState);
  };
  const handleUp = useCallback(createHandler(VOTE_UP), [selected]);
  const handleDown = useCallback(createHandler(VOTE_DOWN), [selected]);
  const [userOnlyHandleUp] = useAnonymousInterceptor(handleUp, null, registerLightboxId);
  const [userOnlyHandleDown] = useAnonymousInterceptor(handleDown, null, registerLightboxId);
  return (
    <VoteBar
      {...props}
      onUpClick={userOnly ? userOnlyHandleUp : handleUp}
      onDownClick={userOnly ? userOnlyHandleDown : handleDown}
      selected={selected}
      sum={sum}
      ups={ups}
      downs={downs}
    />
  );
};
